import { NotebookDialog } from "@/modules/note-taker/notebook-dialog";
import { useNotes } from "creso-core/hooks";
import { Client } from "creso-core/types";
import { format } from "date-fns";
import { ArrowUpRight, MicIcon, NotebookPenIcon } from "lucide-react";
import { Button } from "web-design-system";

export function ClientNotes(props: { client: Client }) {
  const { notes } = useNotes({ clientId: props.client.id });

  const note = notes?.[0];

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-row gap-2 items-center">
        <NotebookDialog
          trigger={({ onClick }) => (
            <button
              onClick={onClick}
              className="flex flex-row hover:shadow-xs border group border-transparent flex-1 gap-2 items-center hover:bg-secondary rounded-md"
            >
              <div className="size-9 rounded-md bg-secondary group-hover:bg-background border border-border flex items-center justify-center">
                <NotebookPenIcon className="size-4" />
              </div>
              <span className="text-sm font-semibold">Notebook</span>
              <div className="size-9 opacity-0 group-hover:opacity-100 transition-opacity duration-150 rounded-md ml-auto bg-transparent border border-transparent flex items-center justify-center">
                <ArrowUpRight className="size-4" />
              </div>
            </button>
          )}
          client={props.client}
          view="notes"
        />
        <NotebookDialog
          trigger={({ onClick }) => (
            <Button
              onClick={onClick}
              size="icon"
              className="ml-auto"
              variant="outline"
            >
              <MicIcon />
            </Button>
          )}
          client={props.client}
          view="notes"
          action="record-note"
        />
      </div>
      {note ? (
        <NotebookDialog
          trigger={({ onClick }) => {
            if (!note) return null;
            return (
              <button
                onClick={onClick}
                className="rounded-lg flex flex-col bg-background p-4 gap-3 border-l-5 border-secondary shadow-none"
              >
                <div className="flex flex-col text-left text-sm gap-3">
                  <div className="flex flex-col gap-1">
                    <p className="font-semibold">{note.title}</p>
                    <p className="text-xs line-clamp-2">{note.summary}</p>
                  </div>
                  <p className="text-xs text-muted-foreground">
                    {format(note.created_at, "PPP")}
                  </p>
                </div>
              </button>
            );
          }}
          note={note}
          client={props.client}
        />
      ) : null}
    </div>
  );
}
